import { green, grey } from 'globals/colors';

export const isStrongPasswordRe = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;
export const isMediumPasswordRe = /(?=.*[a-z])(?=.*[A-Z])(?=.{8,})/;
export const isWeekPasswordRe = /(?=.{8,})/;

interface GetActiveColorProps {
  isStrongPassword: boolean;
  isMediumPassword: boolean;
  isWeekPassword: boolean;
}

export const getActiveColor = ({
  isStrongPassword,
  isMediumPassword,
  isWeekPassword,
}: GetActiveColorProps): string => {
  switch (true) {
    case isStrongPassword:
      return green.V1;
    case isMediumPassword:
      return green.V2;
    case isWeekPassword:
      return green.V3;
    default:
      return grey.V4;
  }
};
